import { For, type JSX } from "solid-js";

import styles from "../deck.module.css";
import type { TextSlide as TextSlideData } from "../types";

/** A slide the practice's staff wrote for this patient: a headline and a few lines. */
export function TextSlide(props: { slide: TextSlideData }): JSX.Element {
  return (
    <div class={styles["txt"]}>
      <h2 class={styles["s-h"]}>{props.slide.headline}</h2>
      <ul class={styles["txt-l"]}>
        <For each={props.slide.lines}>{(line) => <li>{line}</li>}</For>
      </ul>
    </div>
  );
}
